(function () {
  // Original fetch function
  const originalFetch = window.fetch;

  // Override fetch
  window.fetch = function (url, options) {
    // Check if the URL matches the endpoint you want to block
    if (
      typeof url === "string" &&
      url.includes("https://dashboard.shrinetheme.com/api/updates/check")
    ) {
      console.log("Blocked request to:", url);
      return Promise.reject(new Error("Blocked request to specified endpoint"));
    }

    // Call the original fetch function for other requests
    return originalFetch.apply(this, arguments);
  };
})();